<template>
  <section>
    <top-travel-list
      :query="query"
      :selected.sync="selectedItem"
      :loadingItem="loadingItem"
    />

    <hr />

    <top-travel-item
      v-if="selectedItem"
      :id="selectedItem.id"
      :loading.sync="loadingItem"
    />
  </section>
</template>

<script>
import TopTravelList from '@/components/home/TopTravelList'
import TopTravelItem from '@/components/home/TopTravelItem'

export default {
  name: 'TopTravels',
  components: {
    TopTravelList,
    TopTravelItem
  },

  data() {
    const { query } = this.$route

    return {
      query: query,
      loadingItem: false,
      selectedItem: null
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.name === from.name) {
      this.query = to.query
    }

    next()
  }
}
</script>
